module.exports = __webpack_public_path__ + "static/img/m_role.ebb0af0.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/jw/m_role.png
// module id = 2JK7
// module chunks = 7